import React from 'react'
import {FormattedMessage} from 'react-intl'
import {authorIntroductionMaxLength, profileIntroductionMaxLength, UserType} from '../../../config/constants'
import MultipleLinesTextField from '../../fields/fieldWithLabel/MultipleLinesTextField'
import PasswordField from '../../fields/fieldWithLabel/PasswordField'
import TextField from '../../fields/fieldWithLabel/TextField'
import {useUserType} from '../../hocs/hooks'

const SignupFields = () => {
  const userType = useUserType()
  return <>
    {[UserType.holder, UserType.user, UserType.host].includes(userType)
      ? <>
        <div className="row">
          <div className="col-6">
            <TextField name="first" required autoComplete="first" isVertical formClassName="mb-0" placeholder="カーステイ">
              <FormattedMessage id="holder.first"/>
            </TextField>
          </div>
          <div className="col-6">
            <TextField name="last" required autoComplete="last" isVertical formClassName="mb-0" placeholder="太郎">
              <FormattedMessage id="holder.last"/>
            </TextField>
          </div>
        </div>
        <div className="form-text text-muted small mb-2">
          <FormattedMessage id="profile.firstLastNote"
                            defaultMessage="* Please register with your real name on your driver's license"/>
        </div>
      </>
      : <TextField autoComplete="name" name="name" required isVertical>
          <FormattedMessage id="profile.name"/>
        </TextField>
    }
    {[UserType.holder, UserType.user, UserType.host].includes(userType) && <>
      <TextField name="nickname" isVertical placeholder="たろー" formClassName="mb-0">
        <FormattedMessage id="profile.nickname" defaultMessage="Nickname (Optional)"/>
      </TextField>
      <div className="form-text text-muted small mb-2">
        <FormattedMessage id="profile.nicknameNote"
                          defaultMessage="* Please enter if you want to display your profile anonymously."/>
      </div>
    </>}
    {userType === UserType.admin && <TextField name="token" required isVertical>
      <FormattedMessage id="adminSignup.adminToken" defaultMessage="Admin Token"/>
    </TextField>}
    {userType === UserType.author && <TextField name="token" required isVertical>
      <FormattedMessage id="authorSignup.authorToken" defaultMessage="Author Token" />
    </TextField>}
    <TextField name="email" required isVertical>
      <FormattedMessage id="book.email"/>
    </TextField>
    <FormattedMessage id="login.pwd">
      {msg => <PasswordField name="password" required isVertical placeholder={msg}>
        <FormattedMessage id="login.pwd"/>
      </PasswordField>
      }
    </FormattedMessage>
    <FormattedMessage id="login.pwd">
      {msg => <PasswordField name="confirmPassword" required isVertical placeholder={msg}>
        <FormattedMessage id="station.confirmPassword" defaultMessage="Confirm Password"/>
      </PasswordField>
      }
    </FormattedMessage>
    {([UserType.host, UserType.holder].includes(userType)) && <TextField
      name="phone"
      autoComplete="tel"
      isVertical
      placeholder="090xxxxxxxx"
      required>
      <FormattedMessage id="profile.phone" defaultMessage="Phone Number"/>
    </TextField>}
    {[UserType.author].includes(userType)
    && <MultipleLinesTextField name="introduction"
                              required rows={5}
                              maxLength={profileIntroductionMaxLength}
                              isVertical
                              placeholder="北海道出身、東京在住の会社員です。週末は家族4人と愛犬と、キャンプを楽しむのが趣味です。キャンピングカーは初心者ですが車の運転は週2,3回します。">
      <FormattedMessage id="author.introduction"/>
      <FormattedMessage id="holder.textLimit" values={{count: userType === UserType.author
        ? authorIntroductionMaxLength
        : profileIntroductionMaxLength}}/>
    </MultipleLinesTextField>
    }
  </>
}
SignupFields.displayName = 'SignupFields'
export default SignupFields
